export const parseUxfbVisitedOffers = (visitedOffersCookie = ''): number[] => {
  try {
    return JSON.parse(visitedOffersCookie);
  } catch (e) {
    return [];
  }
};
